import React, { Component } from 'react';
import clsx from 'clsx';
import { graphql, QueryRenderer } from 'react-relay';
import environment from '../../environment';
import { withStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import { Typography, Grid, CircularProgress, Button } from '@material-ui/core';

import { useStyles } from './styles.js';

class RightContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  UNSAFE_componentWillReceiveProps(nextProps) {
    console.log('here');
  }

  compon;
  render() {
    const { className, classes, history } = this.props;
    let points = this.props.guest_game2_score + this.props.bonus_points;

    return (
      <Grid className={classes.rightContainerRoot}>
        <Typography className={classes.dashboardDetails}>
          You currently have
        </Typography>

        <Typography className={clsx(classes.dashboardDetails, classes.score)}>
          {points}
        </Typography>
        <Typography className={classes.dashboardDetails}>
          roster spots unlocked
        </Typography>
        <Typography className={(classes.dashboardDetails, classes.terms)}>
          {this.props.draft ? '' : '*including Charley Hoffman'}
        </Typography>

        <QueryRenderer
          environment={environment}
          variables={this.props.variables}
          query={graphql`
            query RightContainerQuery($game_id: ID!) {
              getGameDetails(game_id: $game_id) {
                code
                message
                data {
                  _id
                  game_settings {
                    active
                  }
                }
              }
            }
          `}
          render={({ error, props, retry }) => {
            if (error) {
              return (
                <Typography
                  className={clsx(
                    classes.dashboardDetails,
                    classes.dashboardDraftDetails,
                  )}
                >
                  {this.props.message}
                </Typography>
              );
            } else if (props) {
              // retry();
              if (props.getGameDetails.data.game_settings[0].active) {
                return (
                  <div className={classes.draftButtonContainer}>
                    <Typography
                      className={clsx(
                        classes.dashboardDetails,
                        classes.dashboardDraftDetails,
                      )}
                    >
                      THE DRAFT IS NOW OPEN
                    </Typography>
                    {points < 4 && this.props.landingPage && (
                      <Typography
                        className={clsx(
                          classes.dashboardDetails,
                          classes.dashboardDraftDetails,
                        )}
                      >
                        You must unlock at least four (4) roster spots to
                        participate
                      </Typography>
                    )}
                    {points >= 4 || this.props.show_button ? (
                      <Button
                        className={classes.button}
                        onClick={() => this.props.onDraftButtonClick()}
                      >
                        CLICK HERE TO ENTER DRAFT
                      </Button>
                    ) : (
                      ''
                    )}
                  </div>
                );
              }

              return (
                <Typography
                  className={clsx(
                    classes.dashboardDetails,
                    classes.dashboardDraftDetails,
                  )}
                >
                  {this.props.message}
                </Typography>
              );
            } else {
              return <CircularProgress className={classes.progress} />;
            }
          }}
        />
      </Grid>
    );
  }
}

RightContainer.propTypes = {
  className: PropTypes.string,
};

export default withStyles(useStyles)(RightContainer);
